import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { fmtPoints } from "../data/mock";

export function cellStyle(points, min, max) {
  if (points == null) return { background: "#f8fafc", color: "#cbd5e1" };
  const r = max > min ? (points - min) / (max - min) : 0;
  const hue = Math.round(140 * (1 - r)); // 140 green -> 0 red
  return { background: `hsl(${hue} 75% 92%)`, color: `hsl(${hue} 55% 28%)`, borderColor: `hsl(${hue} 60% 80%)` };
}

function CellBody({ d, locked, isCheapest, style }) {
  const clickable = d.points != null && !locked;
  return (
    <div className={`flex h-14 flex-col justify-between rounded-lg border p-1 text-left transition-transform sm:h-16 sm:p-1.5 ${clickable ? "hover:scale-[1.04]" : ""} ${isCheapest ? "ring-2 ring-blue-500" : ""}`} style={style}>
      <span className="text-xs font-bold">{d.day}</span>
      {locked && <span className="flex items-center gap-0.5 text-[10px] font-bold opacity-70"><Lock className="h-3 w-3" /> PRO</span>}
      {!locked && d.points != null && <span className="text-[11px] font-extrabold leading-tight">{fmtPoints(d.points)}</span>}
      {!locked && d.points == null && <span className="text-[10px]">{d.past ? "" : "—"}</span>}
    </div>
  );
}

// One day in the heatmap: links to search when available, to pricing when PRO-locked.
export default function CalendarCell({ d, locked, isCheapest, min, max, from, to }) {
  const body = <CellBody d={d} locked={locked} isCheapest={isCheapest} style={cellStyle(d.points, min, max)} />;
  if (locked) return <Link to="/pricing" data-testid="calendar-locked-day" title="Unlock with PRO">{body}</Link>;
  if (d.points != null) return <Link to={`/search?from=${from}&to=${to}&date=${d.date}&flex=0`} data-testid="calendar-day">{body}</Link>;
  return <div data-testid="calendar-empty-day">{body}</div>;
}
